module.exports = __webpack_public_path__ + "img/stats_1.86f9f957.png";